import { createSelector } from "reselect"
import { forEach, get } from "lodash"
import { getContentSetsFactors } from "selectors/contentSets"
import { FILTER_TYPES } from "helpers/filters/chips"
import { getModelFactors } from "selectors/modelMetadata"
import { getFilter, getClassifications, getClassificationsValues, getCurrency } from "./filter"

const getSecuritiesDescriptors = state => get(state, "global.data.securityFinderSecuritiesDescriptors.data")

export const getChips = createSelector(
  [getFilter, getModelFactors, getSecuritiesDescriptors, getContentSetsFactors, getClassifications, getClassificationsValues, getCurrency],
  (filter, factorsMetadata, securitiesDescriptors, contentSetsFactors, classificationsMetas, classificationsValues, currency) => {
    const filters = []

    const combinedFactorsMetaData = { ...factorsMetadata, ...contentSetsFactors }
    if (filter) {
      forEach(FILTER_TYPES, filterType => {
        const { field } = filterType
        if (filter[field] && filter[field].length !== 0) {
          filterType.fetcher(filters, {
            filter: filter[field],
            filterType,
            id: field,
            securitiesDescriptors: filterType.field === "securities" ? securitiesDescriptors : combinedFactorsMetaData,
            classificationsInfos: { classificationsMetas, classificationsValues },
            currency,
          })
        }
      })
    }

    return filters
  },
)
